import React from "react";
import { useParams } from "react-router-dom";
import { useDataStudioAssetSearch } from "../../hooks/useDataStudioAssetSearch";
import { DataStudioPage } from "./DataStudioPage";

/**
 * The route's `connectionId` narrows the search to one connector when the user
 * arrived from a connector detail page. Without it the search is tenant-wide,
 * which is what the asset search API is for.
 */
export const DataStudioPageConnected: React.FC = () => {
  const { connectionId } = useParams<{ connectionId?: string }>();
  const assetsQuery = useDataStudioAssetSearch({
    connectionIds: connectionId ? [connectionId] : undefined,
  });

  return (
    <DataStudioPage
      tables={assetsQuery.data?.items ?? []}
      isLoading={assetsQuery.isLoading}
      errorMessage={assetsQuery.errorMessage}
    />
  );
};

export default DataStudioPageConnected;
